export function isInputFocused() {
  return document.activeElement?.tagName === 'INPUT' || document.activeElement?.tagName === 'TEXTAREA'
}
